import { useQuery } from '@tanstack/react-query';
import { AuthNonceHeader, ProfileRewards, type Rewards } from '@/api/spec.ts';
import { environment } from '../../../environment.ts';
import useAppStore from '../../../store/rootStore.ts';
import { getValidNonce } from '../../../store/slices/authSlice.ts';

const EMPTY_REWARDS: Rewards = { at: {}, total_payouts: '0', d: [] };

const fetchProfileRewards = async (authNonce: string): Promise<Rewards> => {
  const response = await fetch(`${environment.apiUrl}${ProfileRewards}`, {
    headers: {
      [AuthNonceHeader]: authNonce,
    },
  });

  if (response.status === 404) {
    return EMPTY_REWARDS;
  }

  if (!response.ok) {
    throw new Error('Failed to fetch rewards');
  }

  return response.json();
};

export const useProfileRewards = () => {
  const isFullyAuthorized = useAppStore((state) => state.isFullyAuthorized());
  const authNonce = useAppStore((state) => getValidNonce(state.authNonce)?.value);
  const referralsEnabled = useAppStore((state) => state.config?.features?.referralsEnabled);

  return useQuery<Rewards>({
    queryKey: ['profile-rewards', authNonce],
    queryFn: () => fetchProfileRewards(authNonce!),
    enabled: isFullyAuthorized && Boolean(authNonce) && referralsEnabled,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
};
